<template lang="pug">
  header.header.header_main(:class="{'header_active': menu, 'header_other' : headerOther, 'header_white' : getChangeLogo}" id="header")
    .header__top
      router-link.header__logo-wrap(to="/")
        // Logo
        svg.header__logo-svg(xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', width='32', height='14', viewBox='0 0 32 14')
          defs
            path#iy4ha(d='M39.44 47.17h-.04l-6.8-.47c-.16 0-.33.13-.33.3v6.5c0 .17.13.3.33.3h6.64c1.83 0 3.33-1.5 3.33-3.33a3.3 3.3 0 0 0-3.13-3.3z')
            path#iy4hb(d='M35.1 43.8h.03l3.3.3c.17 0 .3-.14.37-.27l.76-2.97c.07-.26-.1-.43-.26-.43h-4.04c-.9.03-1.63.77-1.63 1.67-.03.9.63 1.6 1.47 1.7z')
            path#iy4hc(d='M47.54 40.2c-.1-.17-.37-.1-.37.06V53.6c0 .1.1.16.2.16h6.53c.14 0 .24-.13.17-.26z')
            path#iy4hd(d='M63.47 40.2L56.9 53.54c-.07.13.03.26.17.26h6.56c.1 0 .2-.06.2-.16V40.3c0-.2-.26-.26-.36-.1z')
          g
            g(transform='translate(-32 -40)')
              g
                use(:fill='getChangeLogo ? "#000" : "#fff"', xlink:href='#iy4ha')
              g
                use(:fill='getChangeLogo ? "#000" : "#fff"', xlink:href='#iy4hb')
              g
                use(:fill='getChangeLogo ? "#000" : "#fff"', xlink:href='#iy4hc')
              g
                use(:fill='getChangeLogo ? "#000" : "#fff"', xlink:href='#iy4hd')
      StyledLinkEmail(:active='menu || getChangeLogo || headerOther' :href="'mailto:' + $t('base.email')") {{ $t('base.email') }}
      StyledLinkPhone(:active='menu || getChangeLogo || headerOther' :href="'tel:' + parsePhone($t('base.phone'))") {{ $t('base.phone') }}
      .header__toggle(@click='toggleMenu')
        | {{ $t('header.menuTitle') }}
        svg.header__icon-toggle(xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', width='6', height='3', viewBox='0 0 6 3')
          defs
            path#jya7a(d='M340 48l3 3h-6z')
          g
            g(transform='translate(-337 -48)')
              use(fill='gray', xlink:href='#jya7a')
      StyledSocials
        Socials
    Menu(
      :active="menu"
      v-on:close="menu = false"
    )
    // Nav.nav_main(:class="{'nav_active': menu}" :menu="menu" transitionName="transition")
</template>

<script>
// import i18n from '../lang/lang'
import { mapGetters } from 'vuex'
import Nav from '@/components/Nav/Nav'
import Menu from '@/components/Menu'
import Socials from '@/components/Socials'
import {
  StyledLinkPhone,
  StyledLinkEmail,
  StyledSocials
} from './StyledHeader'

export default {
  name: 'Header',
  data () {
    return {
      // mes: i18n.messages
      menu: false,
      headerOther: this.$router.currentRoute.name !== 'MainPage' && this.$router.currentRoute.name !== 'VideoInstruction'
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentLang',
      'getChangeLogo'
    ])
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu
    },
    setLangNew: function (lang) {
      this.$store.dispatch('setLangNew', lang)
    },
    setLang: function (lang) {
      this.$store.dispatch('setLang', lang)
    },
    parsePhone (string) {
      return string.replace(/[^+0-9]/g, '')
    }
  },
  watch: {
    $route (to) {
      to.name !== 'MainPage' && to.name !== 'VideoInstruction' ? this.headerOther = true : this.headerOther = false
    }
  },
  components: {
    Nav,
    Menu,
    StyledLinkPhone,
    StyledLinkEmail,
    StyledSocials,
    Socials
  }
}
</script>

<style scoped>
  .transition-enter-active {
    transition: all .5s ease-out;
  }
  .transition-leave-active {
    transition: all .3s ease-out;
  }
  .transition-enter {
    opacity: 0;
    transform: translateY(-100px);
  }
  .transition-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  }

</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue